<template>
  <div>
    <v-menu v-model="show" :close-on-content-click="false" :max-width="500" offset-y>
      <v-btn
        slot="activator"
        class="builder-icon-button"
        flat
        icon
        :aria-label="adminText('workflowsAll.accreditation_options_0248987', 'Accreditation options')"
        :title="adminText('workflowsAll.accreditation_options_0248987', 'Accreditation options')"
      >
        <img :src="settingsIcon" width="24" height="24" alt="">
      </v-btn>
      <v-card>
        <v-container style="padding-bottom: 0">
          <v-card-title primary-title>
            <span class="dialog-title">{{ adminText('workflowsAll.accreditation_options_0248987', 'Accreditation options') }}</span>
          </v-card-title>
          <v-card-text>
            <v-autocomplete
              v-model="form.format"
              :items="formats"
              :label="adminText('workflowsAll.choose_format_6e8e57b', 'Choose format')"
              type="text"
              :item-text="workflowBuilderFormatLabel"
              return-object
            />
            <v-radio-group v-model="form.orientation" row>
              <v-radio :label="adminText('workflowsAll.portrait_92b6b1b', 'Portrait')" value="PORTRAIT" />
              <v-radio :label="adminText('workflowsAll.landscape_7dc4bea', 'Landscape')" value="LANDSCAPE" />
            </v-radio-group>
            <v-btn v-if="hasBackSide" color="primary" flat @click="disableBackSide">
              {{ adminText('workflowsAll.disable_back_side_2bd2656', 'Disable back side') }}
            </v-btn>
          </v-card-text>
        </v-container>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" flat @click="show = false"> {{ adminText('workflowsAll.cancel_77dfd21', 'Cancel') }} </v-btn>
          <v-btn color="primary" flat @click="saveOptions"> {{ adminText('workflowsAll.save_efc007a', 'Save') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
    <delete-dialog
      :show.sync="openWarningDialog"
      :on-delete="changeOptions"
      :title="adminText('workflowsAll.warning_e9c4556', 'Warning')"
      :content="adminText('workflowsAll.this_action_could_potentially_be_destructive__065ba39', 'This action could potentially be destructive and it is irreversible. Are you sure you want to continue?')"
      :action-message="adminText('workflowsAll.change_format_339ec0e', 'Change format')"
    />
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import DeleteDialog from '../shared/dialogs/delete-dialog.vue'
import { formats } from './builder.utils'
import settingsIcon from '@/assets/builder/settings.svg'

export default {
  name: 'options',
  components: {
    DeleteDialog,
  },
  mixins: [WorkflowDisplay],
  props: {
    options: Object,
    hasBackSide: Boolean,
  },
  data() {
    return {
      settingsIcon,
      form: { ...this.options },
      formats,
      show: false,
      openWarningDialog: false,
    }
  },
  watch: {
    'form.format': function () {
      this.form.orientation = this.form.format.defaultOrientation
    },
  },
  methods: {
    disableBackSide() {
      this.show = false
      this.$emit('disable-back-side')
    },
    saveOptions() {
      this.show = false
      this.openWarningDialog = true
    },
    changeOptions() {
      const {
        orientation,
        format: { name },
      } = this.form
      const format = this.formats.find(f => f.name === name)

      this.$emit('update:options', {
        orientation,
        format,
      })
      this.openWarningDialog = false
    },
  },
}
</script>

<style scoped>
.builder-icon-button {
  width: 48px;
  height: 48px;
  margin: 0 !important;
  color: #0277bd !important;
}
</style>
